import { withStyles } from '@material-ui/core';

import MapWorkspace from './component';
import styles from './styles';

export default withStyles(styles)(MapWorkspace);
